import { Box } from "@mui/material";

import { FormBlock } from "@/forms-design-system/FormBlock/FormBlock";
import { useMediaQuery } from "@/hooks/useMediaQuery";

type ThemedPeerToPeerCampaignFormSummaryLayoutProps = {
  slots: {
    banner?: React.ReactNode;
    campaignLogo?: React.ReactNode;
    status?: React.ReactNode;
    campaignType?: React.ReactNode;
    title: React.ReactNode;
    campaignTarget?: React.ReactNode;
    description?: React.ReactNode;
  };
  forceInlined?: boolean;
};

export const ThemedPeerToPeerCampaignFormSummaryLayout = ({
  slots,
  forceInlined = false,
}: ThemedPeerToPeerCampaignFormSummaryLayoutProps) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <FormBlock
      variant={isSmallScreen || forceInlined ? "inline" : "elevated-card"}
      fullWidth
      sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2 }}
    >
      {!isSmallScreen && slots.banner}
      {slots.campaignLogo}
      {slots.status && <Box marginBlockStart={0.5}>{slots.status}</Box>}
      {slots.title}
      {slots.campaignType}
      {slots.campaignTarget}
      {slots.description}
    </FormBlock>
  );
};
